<template>
    <div>
        <form @submit.prevent="validate">
            <div class="mb-3">
                <h5>Doctor Details</h5>
                <div class="form-group">
                    <label>Profile Photo</label>
                    <div>
                        <input id="uploadProfilePhotoInput" type="file" v-validate="'required|mimes:image/*'" data-vv-as="profile photo file" name="profilePhoto" :class="{'is-invalid':  validationErrors.has('profilePhoto')}">
                        <div v-show="validationErrors.has('profilePhoto')" class="invalid-feedback">
                            {{ validationErrors.first('profilePhoto') }}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Specialty / Specialties</label>
                    <multiple-select-dropdown :options="this.specialtyList" :selectedList="value.specialtyIds" @selected="updateSpecialty" :class="{
                        'is-invalid': specialtyHasError
                    }">
                    </multiple-select-dropdown>
                    <div class="invalid-feedback">
                        Please select at least one specialty.
                    </div>
                </div>

                <div class="form-group">
                    <label>Hospital or Clinic Affiliation</label>
                    <input type="text" name="affiliation" data-vv-validate-on="blur" data-vv-as="hospital or clinic affiliation" placeholder="Hospital or Clinic Affiliation" v-model="value.affiliation" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('affiliation')
                    }">
                    <small>E.g. IJN, Pantai, KPJ, etc</small>
                    <div v-show="validationErrors.has('affiliation')" class="invalid-feedback">
                        {{ validationErrors.first('affiliation') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Years Practicing</label>
                    <input type="text" name="yearsPracticing" data-vv-validate-on="blur" data-vv-as="years practicing" placeholder="Years Practicing" v-model="value.yearsPracticing" v-validate="'required|numeric'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('yearsPracticing')
                    }">
                    <div v-show="validationErrors.has('yearsPracticing')" class="invalid-feedback">
                        {{ validationErrors.first('yearsPracticing') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Education</label>
                    <input type="text" name="education" data-vv-validate-on="blur" data-vv-as="education" placeholder="Education" v-model="value.education" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('education')
                    }">
                    <div v-show="validationErrors.has('education')" class="invalid-feedback">
                        {{ validationErrors.first('education') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Languages Speak</label>
                    <!-- <input type="text" name="languagesSpeak" data-vv-validate-on="blur" data-vv-as="languages speak" placeholder="Languages(s) Speak" v-model="value.languagesSpeak" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('languagesSpeak')
                    }">
                    <small>Separate multiple languages by a comma (,)</small>
                    <div v-show="validationErrors.has('languagesSpeak')" class="invalid-feedback">
                        {{ validationErrors.first('languagesSpeak') }}
                    </div> -->
                    <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                    <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                        The languages speak field is required.
                    </div>
                    <div class="row">
                        <div class="col-6 not-required" v-for="language in languages" :key="language">
                            <input type="checkbox" :id="language" :value="language" v-model="value.languagesSpeak">
                            <label class="ml-2" :for="language">{{ language }}</label>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Work Location Area</label>
                    <input type="text" name="location" data-vv-validate-on="blur" data-vv-as="location" placeholder="Location" v-model="value.location" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('location')
                    }">
                    <small>Please enter your location area in the format of (State / Area). E.g. KL / Ampang, KL / Subang, KL / PJ, KL / Damansara</small>
                    <div v-show="validationErrors.has('location')" class="invalid-feedback">
                        {{ validationErrors.first('location') }}
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="form-group">
                            <label>MMC Number (Malaysian Medical Certificate) <span class="text-primary" style="font-weight: bold;">(Mandatory)</span></label>
                            <input type="text" name="mmcNumber" data-vv-validate-on="blur" data-vv-as="MMC number" placeholder="MMC Number (Malaysian Medical Certificate)" v-model="value.mmcNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('mmcNumber')
                    }">
                            <div v-show="validationErrors.has('mmcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('mmcNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>MMC Document Upload <span class="text-primary" style="font-weight: bold;">(Optional)</span></label>
                            <div>
                                <input id="uploadMMCFileInput" type="file" data-vv-as="MMC document" name="mmcDocument" :class="{'is-invalid':  validationErrors.has('mmcDocument')}">
                                <div v-show="validationErrors.has('mmcDocument')" class="invalid-feedback">
                                    {{ validationErrors.first('mmcDocument') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="form-group">
                            <label>APC Number (Annual Practitioner Certificate) <span class="text-primary" style="font-weight: bold;">(Mandatory)</span></label>
                            <input type="text" name="apcNumber" data-vv-validate-on="blur" data-vv-as="APC number" placeholder="APC Number (Annual Practitioner Certificate)" v-model="value.apcNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('apcNumber')
                    }">
                            <div v-show="validationErrors.has('apcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('apcNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>APC Document Upload <span class="text-primary" style="font-weight: bold;">(Mandatory)</span></label>
                            <div>
                                <div>
                                    <input id="uploadAPCFileInput" type="file" v-validate="'required'" data-vv-as="APC document" name="apcDocument" :class="{'is-invalid':  validationErrors.has('apcDocument')}">
                                    <div v-show="validationErrors.has('apcDocument')" class="invalid-feedback">
                                        {{ validationErrors.first('apcDocument') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <label>APC Expiry Date</label>
                            <input type="text" name="apcExpiry" data-vv-as="APC expiry" data-vv-validate-on="blur" v-model="value.apcExpiry" v-mask="'##/##/####'" v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('apcExpiry')
                    }" />
                            <div v-show="validationErrors.has('apcExpiry')" class="invalid-feedback">
                                {{ validationErrors.first('apcExpiry') }}
                            </div>
                        </div> -->
                    </div>
                </div>

                <!-- <div class="card mb-3">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Borang B Number</label>
                            <input type="text" name="borangBNumber" data-vv-validate-on="blur" data-vv-as="Borang B Number" placeholder="Borang B Number" v-model="value.borangBNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('borangBNumber')
                    }">
                            <div v-show="validationErrors.has('borangBNumber')" class="invalid-feedback">
                                {{ validationErrors.first('borangBNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Borang B Document Upload</label>
                            <div>
                                <input id="uploadBorangBFileInput" type="file" v-validate="'required'" data-vv-as="Borang B document" name="borangBDocument" :class="{'is-invalid':  validationErrors.has('borangBDocument')}">
                                <div v-show="validationErrors.has('borangBDocument')" class="invalid-feedback">
                                    {{ validationErrors.first('borangBDocument') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Bank Account Details</b>
                        </div>

                        <div class="form-group">
                            <label>Payee Name</label>
                            <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank payee name" placeholder="Bank Payee Name" v-model="value.bankAccountPayeeName" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('bankAccountPayeeName')
                        }">
                            <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountPayeeName') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Bank Name</label>
                            <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name" placeholder="Bank Name" v-model="value.bankName" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('bankName')
                        }">
                            <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                                {{ validationErrors.first('bankName') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Bank Account Number</label>
                            <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number" placeholder="Bank Account Number" v-model="value.bankAccountNumber" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('bankAccountNumber')
                        }">
                            <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountNumber') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div>
                <h5>Supporting Documents</h5>
                <p>Please submit the following documents for review purposes.</p>
            </div> -->
        </form>
    </div>
</template>

<script>
import multipleSelectDropdown from '@/components/multiple-select-dropdown';
import languages from '@/config/languages';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'RegisterDoctorComponent',
    'components': {
        multipleSelectDropdown
    },
    'directives': {
        mask
    },
    'props': {
        'value': Object
    },
    data () {
        return {
            'specialtyList': [],
            'specialtyHasError': false,
            'languagesSpeakHasError': false,
            languages
        };
    },
    mounted () {
        this.retrieveSpecialtyList();
    },
    'methods': {
        validate () {
            if (this.value.specialtyIds.length === 0) {
                this.specialtyHasError = true;
                return Promise.reject(new Error('Specialty cannot be empty'));
            } else {
                this.specialtyHasError = false;
            }

            if (this.value.languagesSpeak.length === 0) {
                this.languagesSpeakHasError = true;
                return Promise.reject(new Error('Languages Speak cannot be empty'));
            } else {
                this.languagesSpeakHasError = false;
            }
            return this.$validator.validateAll();
        },
        retrieveSpecialtyList () {
            this.axios.get('/Doctor/GetDoctorSpecialties').then(({
                data
            }) => {
                let list = data.data;

                // this.specialtyList = list.map((i) => {
                //     return {
                //         'value': i.si,
                //         'text': i.sn
                //     };
                // });
                for (let doctorSpecialty of list) {
                    this.specialtyList.push({
                        'value': doctorSpecialty.si,
                        'text': JSON.parse(doctorSpecialty.sn).en
                    });
                }
            });
        },
        // listen change of specialty, update,
        updateSpecialty (selectedValue) {
            // find index of selectedItem
            let selectedIndex = this.value.specialtyIds.findIndex((s) => s === selectedValue);

            if (selectedIndex > -1) {
                this.value.specialtyIds.splice(selectedIndex, 1);
            } else {
                this.value.specialtyIds.push(selectedValue);
            }
        }
    }
};
</script>
